module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"claim.payment":"การเรียกเก็บเงิน","claim.payment.description":"สถานะการเรียกเก็บเงินกับทาง HGR","claim.field.payment_request_remark.placeholder":"เช่น ได้รับเป็นเครดิตจากทาง HGR หรือ กำลังรอทาง HGR และ RCC อยู่ เป็นต้น"}}')
  delete Component.options._Ctor
}
